<template>
  <header class="header-container">
    <!-- Background Video/Image -->
    <video v-if="heroVideo" autoplay muted loop class="background-video">
      <source :src="heroVideo" type="video/mp4">
    </video>
    <div v-else-if="heroImage" class="background-video">
      <img :src="heroImage" width="100%" alt="Hero" />
    </div>
    <video v-else autoplay muted loop class="background-video">
      <source src="../assets/video.mp4" type="video/mp4">
    </video>

    <div class="video-overlay"></div>

    <div class="header-content">
      <div class="content-wrapper">
        <div class="cover-left">
          <div class="eyebrow">{{ eyebrow }}</div>
          <h1 class="cover-title" v-html="titleHtml"></h1>
          <router-link v-if="ctaLink" :to="ctaLink">
            <button class="cta-button">{{ ctaText }}</button>
          </router-link>
          <button v-else class="cta-button">{{ ctaText }}</button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import api from '@/services/api';
import { mediaUrl } from '@/services/media';

export default {
  name: 'Header',
  data() {
    return {
      eyebrow: 'VISION, MISSION & VALUES',
      titleLines: ['COMMUNITY,', 'INNOVATION,', 'SUCCESS'],
      ctaText: 'Get Started',
      ctaLink: '/sasadmission',
      heroVideo: null,
      heroImage: null,
    }
  },
  computed: {
    titleHtml() {
      return this.titleLines.join('<br />');
    }
  },
  async created() {
    try {
      // Call individual endpoint directly
      const data = await api.getHeroSliders();
      const sliders = api.extractList(data);
      if (sliders.length > 0) {
        const hero = sliders[0];
        if (hero.subtitle) this.eyebrow = hero.subtitle;
        if (hero.title) this.titleLines = hero.title.split('\n');
        if (hero.cta_text) this.ctaText = hero.cta_text;
        if (hero.cta_link) this.ctaLink = hero.cta_link;
        // Serializer provides: image (alias for background_image), video (alias for background_video)
        const vid = hero.video || hero.background_video;
        const img = hero.image || hero.background_image;
        if (vid) this.heroVideo = mediaUrl(vid);
        else if (img) this.heroImage = mediaUrl(img);
      }
    } catch (e) {
      console.warn('[Header] API failed, using fallback:', e.message);
    }
  }
}
</script>

<style scoped>
* { margin: 0; padding: 0; box-sizing: border-box; }
.header-container { position: relative; width: 100%; height: 100vh; min-height: 600px; overflow: hidden; display: flex; align-items: center; justify-content: center; }
.background-video { position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; z-index: 1; }
.background-video img { width: 100%; height: 100%; object-fit: cover; }
.video-overlay { position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: linear-gradient(135deg, rgba(192, 33, 48, 0.6) 0%, rgba(247, 240, 43, 0.3) 100%); z-index: 2; }
.header-content { position: relative; z-index: 3; width: 100%; height: 100%; display: flex; align-items: flex-end; justify-content: flex-start; padding: 40px 20px; }
.content-wrapper { max-width: 800px; animation: fadeInUp 1s ease-out; }
@keyframes fadeInUp { from { opacity: 0; transform: translateY(40px); } to { opacity: 1; transform: translateY(0); } }
.cover-left { max-width: 55%; color: white; text-shadow: 0 6px 20px rgba(0,0,0,0.6); }
.eyebrow { font-size: 14px; font-weight: 800; letter-spacing: 2px; color: rgba(255,255,255,0.95); margin-bottom: 8px; }
.cover-title { font-size: 84px; line-height: 0.95; margin: 0; font-weight: 900; letter-spacing: -2px; }
.cta-button { padding: 18px 50px; font-size: 16px; font-weight: 700; color: white; background: linear-gradient(135deg, #C02130 0%, #F7F02B 100%); border: none; border-radius: 50px; cursor: pointer; transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1); box-shadow: 0 15px 40px rgba(192, 33, 48, 0.4); letter-spacing: 0.5px; animation: fadeInUp 0.8s ease-out 0.4s backwards; }
.cta-button:hover { transform: translateY(-3px); box-shadow: 0 20px 50px rgba(192, 33, 48, 0.6); }
.cta-button:active { transform: translateY(-1px); }
@media (max-width: 768px) { .header-content { align-items: flex-end; justify-content: flex-start; } .content-wrapper { max-width: 100%; } .cover-left { max-width: 100%; } .cover-title { font-size: 48px; line-height: 1.1; } .cta-button { margin-top: 20px; } }
@media (max-width: 480px) { .header-content { padding: 20px; } .eyebrow { font-size: 12px; letter-spacing: 1.5px; } .cover-title { font-size: 36px; line-height: 1.15; } .cta-button { width: 100%; padding: 14px 0; font-size: 14px; } }
</style>
